export function getOptOutErrorLink() {
  return "https://support.vitalsource.com/hc/en-us/articles/360039705814-Opt-out-Error-Messages";
}

export function submitVitalSourceSupport() {
  return "https://support.vitalsource.com/hc/en-us/requests/new";
}
